import { putResolve } from 'redux-saga/effects';
import { PICO_API_URL } from '@piconetworks/pkg-endpoints';
import { REQUEST } from './actionTypes.js';

function picoAPIHelper(_ref) {
  var _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'get' : _ref$method,
    url = _ref.url,
    _ref$headers = _ref.headers,
    headers = _ref$headers === void 0 ? {} : _ref$headers,
    data = _ref.data;
  return function* () {
    var _yield$putResolve = yield putResolve({
        type: REQUEST,
        config: {
          url: url,
          method: method,
          baseURL: PICO_API_URL(),
          headers: Object.assign({
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }, headers),
          timeout: 30000,
          data: data
        }
      }),
      response = _yield$putResolve.data,
      status = _yield$putResolve.status;
    return {
      data: response,
      status: status
    };
  }();
}

export { picoAPIHelper as default };
//# sourceMappingURL=picoApiHelper.js.map
